import React from 'react';
import SectionHeading from '../UI/SectionHeading';
import FloatingLines from '../UI/FloatingLines';
import './BenefitsSection.css';

const BenefitsSection: React.FC = () => {
  const benefits = [
    {
      icon: 'api-team',
      title: 'Специализированная команда',
      description: 'Наши специалисты всегда готовы ответить на вопросы через Telegram или Email.',
      highlight: '#FFD700' // Gold color for icon highlight
    },
    {
      icon: 'graphql',
      title: 'AI использует нейросети',
      description: 'Гибкость в выборе вариантов планировок с учетом всех ваших требований.',
      highlight: '#4299E1' // Blue color for icon highlight
    },
    {
      icon: 'workflow',
      title: 'Ускорение рабочего процесса',
      description: 'Автоматизируйте проектирование и анализируйте данные для оптимальных решений.',
      highlight: '#F56565' // Red color for icon highlight
    }
  ];

  return (
    <section id="benefits" className="benefits-section section">
      {/* Add floating lines background effect */}
      <FloatingLines className="benefits-floating-lines" density={3} />
      
      <div className="container">
        <SectionHeading 
          title="Испытайте свободу создавать решения моментально"
          subtitle="Используйте возможности нашей платформы для создания профессиональных планировок для ваших клиентов - или просто для вашей команды."
        />
        
        <div className="benefits-grid">
          {benefits.map((benefit, index) => (
            <div key={index} className="benefit-item">
              <div className="benefit-icon-container">
                <div className="benefit-icon-wrapper" style={{ '--highlight-color': benefit.highlight } as React.CSSProperties}>
                  <div className={`benefit-icon benefit-icon-${benefit.icon}`}></div>
                </div>
              </div>
              <h3 className="benefit-title">{benefit.title}</h3>
              <p className="benefit-description">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;